module.exports = __webpack_public_path__ + "img/step1.21860ea9.png";